import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { NotificationService } from '../../../../services/notification.service';
import { RekbotNotesService } from '../../../../services/rekbots-notes.service';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-note-delete-confirm',
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatIcon,
    MatInputModule,
    MatButtonModule,
    CommonModule
  ],
  templateUrl: './modal-note-delete-confirm.component.html',
  styleUrl: './modal-note-delete-confirm.component.css',
  providers: [RekbotNotesService]
})
export class ModalNoteDeleteConfirmComponent  {

  deleteReson:FormControl = new FormControl('',[ Validators.required, Validators.minLength(10) ]) ;
  noteId!: number;
  rekbotId!: number;

  constructor(
    private rekbotNotesService: RekbotNotesService,
    private noificationService: NotificationService,
    private dialogRef: MatDialogRef<ModalNoteDeleteConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.noteId = data.noteId;
    this.rekbotId = data.rekbotId;
  }

  onSubmit() {
    console.log("submitting delete request");
    console.log(this.deleteReson.value);
    console.log(this.deleteReson.valid);
    
    if(this.deleteReson.valid) {
      this.rekbotNotesService.requestDeleteNote(this.rekbotId, this.noteId, this.deleteReson.value)
        .subscribe({
          next: (res) => {
            console.log("Żądanie usunięcia notatki wysłane pomyślnie", res);
            this.noificationService.pushNotification("Wysłano żądanie usunięcia wpisu","info",5000);
            this.dialogRef.close("success");
          },
          error: err => {
            this.noificationService.pushNotification("Błąd podczas wysyłania żądania usunięcia wpisu","error",5000);
            console.error(err);
          }
        })
    }
  }
}
